import { render, staticRenderFns } from "./Parlor-3.2.4.vue?vue&type=template&id=37a62074&scoped=true&"
import script from "./Parlor-3.2.4.vue?vue&type=script&lang=js&"
export * from "./Parlor-3.2.4.vue?vue&type=script&lang=js&"
import style0 from "./Parlor-3.2.4.vue?vue&type=style&index=0&id=37a62074&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a62074",
  null
  
)

export default component.exports